import React from 'react';

import { normalizeSearchTerm } from '../../utils/helpers';
import PlayMovie from '../../svgs/play-movie.svg';
import AudioTrack from '../../svgs/audio-track.svg';
import AutoPlay from '../../svgs/auto-play.svg';
import Enjoy from '../../svgs/enjoy.svg';

import './HowToCards.scss';

const HowToCards = () => {
  const cardData = [
    {
      text: 'Play a movie or show on your TV.',
      icon: <PlayMovie className="how-to-cards__img" />,
    },
    {
      text: 'Start an audio description track on your device.',
      icon: <AudioTrack className="how-to-cards__img" />,
    },
    {
      text: 'After syncing, your track will automatically play.',
      icon: <AutoPlay className="how-to-cards__img" />,
    },
    {
      text: 'Enjoy your movie or show with audio description!',
      icon: <Enjoy className="how-to-cards__img" />,
    },
  ];

  const renderCards = cardData.map((card) => (
    <li key={normalizeSearchTerm(card.text)}>
      <figure className="how-to-cards__figure">
        {card.icon}
        <figcaption className="how-to-cards__caption">{card.text}</figcaption>
      </figure>
    </li>
  ));

  return (
    <div className="how-to-cards">
      <ul className="how-to-cards__wrapper">{renderCards}</ul>
      <a
        className="how-to-cards__link"
        href="https://www.spectrum.com/apps/spectrum-access-app"
        aria-label="Learn more about using the Spectrum Access app"
      >
        Learn More
      </a>
    </div>
  );
};

export default HowToCards;
